import React, {useEffect, useState} from 'react';
import {Trans, useTranslation} from 'react-i18next';

import '../../Custom.css';
import {
    ContextualMenuItemType,
    DefaultButton,
    DetailsListLayoutMode,
    IButtonStyles,
    IColumn,
    IconButton,
    IContextualMenuProps,
    Modal,
    Nav,
    Panel,
    PanelType,
    SelectionMode,
    Separator,
    ShimmeredDetailsList,
    Spinner,
    SpinnerSize,
    Stack,
    StackItem,
    Text
} from "@fluentui/react";
import {ApprovalListDetails, ApprovalListEdit, contentStyles, iconButtonStyles, navStyles} from "./index"
import {useBranding} from '../../hooks/useBranding';
import StatusMessage, {StatusEnum} from "../../share/StatusMessage";
import ApprovalService, {
    IDeleteApprovalListMasterRequest,
    IGetApprovalListMasterRequest,
    IGetApprovalListMasterResponse
} from "../../services/Approval";
import CustomDialog from '../../share/CustomDialog';

type Properties = {
    titleId: string,
    cancel: any
    getLinkGroup: any
    option: string
    setIsOpenMenu: any
    showModal: any
    onLinkClick: any
    templateId: string,
    documentOnlyAudienceId: string,
    isOpenMenu: any
}

export function ApprovalLists({
                                  showModal,
                                  option,
                                  templateId,
                                  documentOnlyAudienceId,
                                  getLinkGroup,
                                  titleId,
                                  cancel,
                                  isOpenMenu,
                                  onLinkClick,
                                  setIsOpenMenu
                              }: Properties) {

    const {branding} = useBranding()
    const {t} = useTranslation(['approval', 'common'])
    const iconListButtonStyles: Partial<IButtonStyles> = {root: {float: 'left', height: 'inherit'}};

    const [showListDetails, setShowListDetails] = useState(false)
    const [showEditList, setShowEditList] = useState(false)
    const [showDeleteList, setShowDeleteList] = useState(false)
    const [showMessage, setShowMessage] = useState(false)
    const [statusMessage, setStatusMessage] = useState<StatusEnum>(StatusEnum.Info)
    const [hasTimerMessage, setHasTimerMessage] = useState(false)
    const [message, setMessage] = useState("")
    const [isLoadedData, setIsLoadedData] = useState(false)
    const [isDeleting, setIsDeleting] = useState(false)
    const [lists, setLists] = useState<IGetApprovalListMasterResponse[]>([])
    const [isLoading, setIsLoading] = useState(true)
    const [selectedList, setSelectedList] = useState<IGetApprovalListMasterResponse | undefined>(undefined)

    useEffect(() => {
        if (showModal) {
            initLoad().then()
        }
    }, [])


    const menuContextual = (item: IGetApprovalListMasterResponse): IContextualMenuProps => {

        return {
            items: [
                // {
                //     key: 'editDescription',
                //     text: t("Common.MenuAction.Edit", {ns: "common"}),
                //     title: t("Common.MenuAction.Edit", {ns: "common"}),
                //     iconProps: {iconName: 'Edit'},
                //     onClick: () => {
                //         onShowEditList(item)
                //     }
                // },
                {
                    key: 'listDetails',
                    text: t("title.showListDetails", {ns: "approval"}),
                    title: t("title.showListDetails", {ns: "approval"}),
                    iconProps: {iconName: 'BacklogList'},
                    onClick: () => {
                        onShowListDetails(item)
                    }
                },
                {
                    key: 'Divider2',
                    itemType: ContextualMenuItemType.Divider
                },
                {
                    key: 'delete',
                    text: t("Common.MenuAction.Delete", {ns: "common"}),
                    title: t("Common.MenuAction.Delete", {ns: "common"}),
                    iconProps: {iconName: 'Trash'},
                    onClick: () => {
                        onShowDeleteList(item)
                    }
                }

            ],
            directionalHintFixed: true,
        }
    };

    const approvalListColumns: IColumn[] = [
        {
            key: 'column1',
            name: t('label.ctrlName', {ns: 'common'}),
            fieldName: 'Name',
            minWidth: 240,
            maxWidth: 240,
            isMultiline: false,
            isResizable: true,
            onRender: (item: IGetApprovalListMasterResponse) => {
                return <>
                    <StackItem styles={{
                        root: {
                            justifyContent: "start",
                            alignItems: "center",
                            display: "flex",
                            height: "100%"
                        }
                    }}>
                        <Text block variant={"smallPlus"}
                              styles={{
                                  root: {
                                      width: '100%',
                                      whiteSpace: 'nowrap',
                                      textOverflow: 'ellipsis',
                                      overflow: 'hidden'
                                  }
                              }}
                              title={item.Name}>
                            {item.Name}

                        </Text>
                    </StackItem>
                </>
            }
        },
        {
            key: 'column2',
            name: t('label.ctrlDescription', {ns: 'common'}),
            fieldName: 'Description',
            minWidth: 200,
            isMultiline: false,
            isResizable: true,
            isCollapsible: true,
            onRender: (item: IGetApprovalListMasterResponse) => {
                return <>
                    <StackItem styles={{
                        root: {
                            justifyContent: "start",
                            alignItems: "center",
                            display: "flex",
                            height: "100%"
                        }
                    }}>
                        <Text block variant={"smallPlus"}
                              styles={{
                                  root: {
                                      width: '100%',
                                      whiteSpace: 'nowrap',
                                      textOverflow: 'ellipsis',
                                      overflow: 'hidden'
                                  }
                              }}
                              title={item.Description}>
                            {item.Description}

                        </Text>
                    </StackItem>
                </>
            }

        },
        {
            key: 'column5',
            name: t('title.actions', {ns: 'approval'}),
            minWidth: 50,
            maxWidth: 50,
            isMultiline: false,
            isResizable: false,
            onRender: (item: IGetApprovalListMasterResponse) => {
                return <>
                    <StackItem styles={{
                        root: {
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                            height: "100%"
                        }
                    }}>

                        <IconButton
                            menuIconProps={{iconName: 'MoreVertical', style: {fontSize: 20, color: '#242424'}}}
                            role="button"
                            title={t('label.colShowActions', {ns: 'common'})}
                            data={item}
                            disabled={isDeleting}
                            aria-haspopup
                            aria-label={t('label.colShowActions', {ns: 'common'})}
                            styles={iconListButtonStyles}
                            menuProps={menuContextual(item)}
                        />
                    </StackItem>
                </>

            }
        }
    ]


    /**
     * Load init
     */
    const initLoad = async () => {
        setMessage("")
        setShowMessage(false)
        setIsLoadedData(false)
        setIsLoading(true)
        setLists([])
        setHasTimerMessage(false)

        const request: IGetApprovalListMasterRequest = {
            Mode: 'audienceId',
            Id: documentOnlyAudienceId
        }

        await ApprovalService.getApprovalListMaster(request)
            .then(data => {
                if (data.Success) {
                    const resultData = JSON.parse(data.Result) as Array<IGetApprovalListMasterResponse>
                    if (Array.isArray(resultData)) {
                        setLists(resultData.sort((a, b) => a.Name.localeCompare(b.Name)))
                        setIsLoadedData(true)
                    } else {
                        showStatusMessage(t('message.notFound', {ns: 'common'}), StatusEnum.Error)
                    }
                } else {
                    showStatusMessage(t('message.error', {
                        ns: 'common',
                        Error: data.ExceptionMessage
                    }), StatusEnum.Error)
                }
            })
            .catch((error) => {
                showStatusMessage(t('message.error', {ns: 'common', Error: error.message}), StatusEnum.Error)
            })
            .finally(() => {
                setIsLoading(false)
            })

    }

    /**
     * show Status Message
     * @param message
     * @param status
     */
    const showStatusMessage = (message: string, status: StatusEnum) => {
        setMessage(message)
        setStatusMessage(status)
        setShowMessage(true)
    }


    /**
     * Callback function that handles the closure of the edit list dialog or modal.
     *
     * This function is used to update the display or state when the edit list action
     * is completed or cancelled. It optionally triggers an asynchronous operation to
     * refresh or reload approval steps if the `update` parameter is true.
     *
     * @param {boolean} [update=false] - A boolean flag indicating whether to trigger
     *                                   a reload of approval steps. Defaults to false.
     */
    const onCloseEditList = (update: boolean = false) => {
        setShowEditList(false)

        if (update) {
            initLoad().then()
        }
    }


    /**
     * A function that handles the closure of the list details view.
     *
     * This function performs the following operations:
     * 1. Hides the edit list UI by setting the `setShowEditList` state to `false`.
     * 2. If the `update` parameter is true, triggers the `initLoad` function to reload or reinitialize data.
     *
     * @param {boolean} [update=false] - Indicates whether to trigger a data reinitialization process upon closing the list details.
     */
    const onCloseListDetails = (update: boolean = false) => {
        setShowListDetails(false)

        if (update) {
            initLoad().then()
        }
    }


    /**
     * A function that, when invoked, sets the state to display the edit list modal or component.
     * This function updates the state variable to true, triggering the visibility of the edit list.
     *
     * @function
     */
    const onShowEditList = (item: IGetApprovalListMasterResponse | undefined = undefined) => {
        setSelectedList(item)
        setShowEditList(true)
    }


    /**
     * Handles the action of showing the details of a specific list item.
     *
     * @param {IGetApprovalListMasterResponse|undefined} [item=undefined] - The list item for which details should be displayed. If undefined, no specific item is selected.
     */
    const onShowListDetails = (item: IGetApprovalListMasterResponse | undefined = undefined) => {
        setSelectedList(item)
        setShowListDetails(true)
    }


    /**
     * Handles the visibility and selection of the delete list modal.
     *
     * @param {IGetApprovalListMasterResponse | undefined} [item=undefined] - The selected item to be set before showing the delete list modal. If undefined, no item is preselected.
     */
    const onShowDeleteList = (item: IGetApprovalListMasterResponse | undefined = undefined) => {
        setSelectedList(item)
        setShowDeleteList(true)
    }


    const deleteList = async () => {
        setMessage("")
        setShowMessage(false)
        setIsDeleting(true)
        setShowDeleteList(false)

        const request: IDeleteApprovalListMasterRequest = {
            Id: String(selectedList?.Id),
            AudienceId: documentOnlyAudienceId
        }

        await ApprovalService.deleteApprovalListMaster(request)
            .then(data => {
                if (data.Success) {
                    initLoad().then()
                } else {
                    showStatusMessage(t('message.error', {
                        ns: 'common',
                        Error: data.ExceptionMessage
                    }), StatusEnum.Error)
                }
            })
            .catch((error) => {
                showStatusMessage(t('message.error', {ns: 'common', Error: error.message}), StatusEnum.Error)
            })
            .finally(() => {
                setIsDeleting(false)
            })

    }


    return (
        <>
            <Modal
                isOpen={showModal}
                isBlocking={true}
                containerClassName={contentStyles(branding.theme).newContainer}
            >

                <Stack grow={1} styles={{root: {height: "100%"}}}>

                    <Stack tokens={{childrenGap: 8}} styles={{
                        root: {
                            height: 56,
                            alignItems: 'center'
                        }
                    }} horizontal>

                        <Stack className="ms-hiddenXlUp">

                            <IconButton iconProps={{iconName: 'GlobalNavButton'}}
                                        style={{marginLeft: "-4px", paddingLeft: "16px"}}
                                        title={t('text.Menu', {ns: 'workspace'})} onClick={setIsOpenMenu}/>
                            <Panel
                                isBlocking={false}
                                isOpen={isOpenMenu}
                                onDismiss={setIsOpenMenu}
                                closeButtonAriaLabel={t('Common.Button.Close', {ns: 'common'})}
                                type={PanelType.smallFixedNear}
                            >
                                <Nav
                                    groups={getLinkGroup}
                                    onLinkClick={onLinkClick}
                                    selectedKey={option}
                                    styles={navStyles}
                                />
                            </Panel>

                        </Stack>

                        <Stack grow={1}
                               styles={{
                                   root: {
                                       textOverflow: "ellipsis",
                                       paddingLeft: 16,
                                       whiteSpace: "nowrap",
                                       overflow: "hidden"
                                   }
                               }}>
                            <Text
                                variant={"xLarge"}
                                id={titleId}
                                title={t('title.approvalLists', {ns: 'approval'})}>
                                {t('title.approvalLists', {ns: 'approval'})}
                            </Text>
                        </Stack>

                        <Stack horizontal styles={{root: {alignItems: "center", paddingRight: 8}}}>
                            <IconButton
                                styles={iconButtonStyles}
                                iconProps={{iconName: 'Cancel'}}
                                ariaLabel={t('Common.Button.Close', {ns: 'common'})}
                                onClick={cancel}
                                title={t('Common.Button.Close', {ns: 'common'})}
                            />
                        </Stack>
                    </Stack>
                    <Stack grow={1} styles={{root: {height: 1}}}>

                        <Stack horizontal styles={{root: {height: '100%'}}}>

                            <Stack className={"ms-hiddenLgDown scrollVisible"} styles={{
                                root: {
                                    overflowY: 'auto',
                                    height: '100%',
                                    width: 240, paddingLeft: 16
                                }
                            }}>
                                <Nav
                                    groups={getLinkGroup}
                                    onLinkClick={onLinkClick}
                                    selectedKey={option}
                                    styles={navStyles}
                                />
                            </Stack>

                            <Stack grow={1} styles={{root: {height: '100%', width: 1}}}>


                                <Stack grow={1} styles={{root: {overflowY: 'auto', paddingLeft: 16, paddingRight: 16}}}
                                       className="scrollVisible">


                                    {showMessage &&
                                        <>
                                            <Stack styles={{root: {paddingTop: 8}}}>
                                                <StatusMessage status={statusMessage}
                                                               hasTimer={hasTimerMessage}
                                                               truncated={true}
                                                               isMultiline={true}
                                                               dismiss={true}

                                                               setShowMessage={setShowMessage}>
                                                    <div>{message}</div>
                                                </StatusMessage>
                                            </Stack>
                                        </>
                                    }

                                    <Stack horizontal styles={{root: {alignItems: "center"}}}>
                                        <StackItem grow={1}>
                                            <Text variant={'large'}>
                                                {t('title.approvalLists', {ns: 'approval'})}
                                            </Text>
                                        </StackItem>
                                        <StackItem>
                                            <DefaultButton
                                                title={t('text.addList', {ns: 'approval'})}
                                                text={t('text.addList', {ns: 'approval'})}
                                                disabled={!isLoadedData || isDeleting}
                                                onClick={() => {
                                                    onShowEditList(undefined)
                                                }}
                                            />
                                        </StackItem>
                                    </Stack>

                                    <ShimmeredDetailsList
                                        items={lists}
                                        enableShimmer={isLoading}
                                        compact={false}
                                        columns={approvalListColumns}
                                        selectionMode={SelectionMode.none}
                                        layoutMode={DetailsListLayoutMode.justified}
                                        isHeaderVisible={true}
                                        isSelectedOnFocus={false}
                                        setKey={"Id"}
                                    />

                                    {lists.length === 0 && !isLoading &&
                                        <>
                                            <p style={{textAlign: "center"}}>
                                                <Text variant={'small'}>
                                                    <Trans>
                                                        {t('text.emptyList', {ns: 'approval'})}
                                                    </Trans>
                                                </Text>
                                            </p>
                                        </>
                                    }

                                </Stack>


                                {/*-- START FOOTER --*/}
                                <Separator></Separator>
                                <Stack horizontal tokens={{childrenGap: 8}}
                                       styles={{root: {paddingRight: 16, paddingBottom: 12, alignItems: 'center'}}}>
                                    <Stack grow={1}>&nbsp;</Stack>
                                    {isLoading &&
                                        <>
                                            <StackItem>
                                                <Spinner size={SpinnerSize.medium} labelPosition="left"
                                                         label={t('text.spinner', {ns: 'common'})}/>
                                            </StackItem>
                                        </>
                                    }

                                    {isDeleting &&
                                        <>
                                            <StackItem>
                                                <Spinner size={SpinnerSize.medium} labelPosition="left"
                                                         label={t('text.spinnerDeleting', {ns: 'common'})}/>
                                            </StackItem>
                                        </>
                                    }

                                    <Stack horizontal tokens={{childrenGap: 8}} wrap={false}>


                                        <DefaultButton onClick={cancel}
                                                       text={t('Common.Button.Close', {ns: 'common'})}
                                                       title={t('Common.Button.Close', {ns: 'common'})}/>

                                    </Stack>
                                </Stack>

                                <CustomDialog
                                    title={t('title.deleteList', {ns: 'approval', Name: selectedList?.Name ?? ''})}
                                    titleId={`removeStep${templateId}`}
                                    actionText={t('Common.Button.Delete', {ns: 'common'})}
                                    confirm={deleteList}
                                    close={() => {
                                        setShowDeleteList(false)
                                    }}
                                    isOpen={showDeleteList}
                                >
                                    <Trans>
                                        {t('text.confirmRemoveList', {ns: 'approval'})}
                                    </Trans>
                                </CustomDialog>

                                {showListDetails &&
                                    <ApprovalListDetails
                                        list={selectedList}
                                        documentOnlyAudienceId={documentOnlyAudienceId}
                                        onDismissModal={onCloseListDetails}
                                        showModal={showListDetails}/>
                                }

                                {showEditList &&
                                    <ApprovalListEdit
                                        showModal={showEditList}
                                        documentOnlyAudienceId={documentOnlyAudienceId}
                                        item={selectedList}
                                        onDismissModal={onCloseEditList}
                                    />
                                }

                            </Stack>
                        </Stack>
                    </Stack>
                </Stack>
            </Modal>
        </>
    )
}
